import axios from "axios";

class Request {
  static createInstance = () => {
    return axios.create({
      baseURL: window.BASE_API,
      headers: {
        "App-Code": window.APP_CODE,
        Authorization: window.USER_TOKEN || ""
      }
    });
  };

  static get(...args) {
    return Request.createInstance().get(...args);
  }

  static post(...args) {
    return Request.createInstance().post(...args);
  }

  static put(...args) {
    return Request.createInstance().put(...args);
  }

  static patch(...args) {
    return Request.createInstance().patch(...args);
  }

  static delete(...args) {
    return Request.createInstance().delete(...args);
  }

  static head(...args) {
    return Request.createInstance().head(...args);
  }

  static request(...args) {
    return Request.createInstance().request(...args);
  }

  static options(...args) {
    return Request.createInstance().options(...args);
  }
}

export default Request;
